'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { useState } from 'react';
import { useTheme } from 'next-themes';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { ThemeProvider } from '@/components/theme-provider';
import { DeploymentWatcher } from '@/components/deployment-watcher';

/**
 * Toaster, следующий за системной темой
 */
function ThemedToaster() {
  const { resolvedTheme } = useTheme();
  return <Toaster position="top-right" richColors theme={(resolvedTheme as 'light' | 'dark') || 'dark'} containerAriaLabel="Уведомления" />;
}

/**
 * Провайдеры приложения
 */
export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000,
            refetchOnWindowFocus: false,
          },
        },
      })
  );

  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <NuqsAdapter>
          {children}
          <ThemedToaster />
          <DeploymentWatcher />
        </NuqsAdapter>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
